import { useQueryClient } from '@tanstack/react-query';

import { UpdateRequest, Vault, VaultOperation, VaultVersion } from '@playq/services-vault';
import { GenericFailure } from '@playq/services-shared';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';
import { snackbarService } from '/common/snackbarService';
import { useSyncEnvWithPath } from '/hooks/useSyncEnvWithPath';

import { playerLookupKeys } from './constants';

export const useUpdateVault = (
  data: Vault,
  options?: UseMutationOptionsExtended<Vault, GenericFailure | Error, { vaultData: UpdateRequest }>
) => {
  const { env } = useSyncEnvWithPath();
  const queryClient = useQueryClient();

  const { mutateAsync } = useEitherMutation(
    ({ vaultData }) => services2.vaultLookupService.updateVault(vaultData, env),
    {
      ...options,
    }
  );
  const executeOperation = async (operations: VaultOperation[], { successMessage }: { successMessage: string }) => {
    const request = new UpdateRequest();
    request.operations = operations;
    request.target = data.id;
    request.expectedVersion = new VaultVersion({ version: data?.version?.version ?? 0 });

    try {
      await mutateAsync({ vaultData: request });
      await queryClient.invalidateQueries({ queryKey: playerLookupKeys.allVaults() });
      snackbarService.success(successMessage);
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  };
  return executeOperation;
};
